import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

const GlobalStyles = () => (
  <MuiGlobalStyles
    styles={(theme) => ({
      '*': {
        boxSizing: 'border-box',
      },
      html: {
        height: '100%',
        scrollBehavior: 'smooth',
      },
      body: {
        height: '100%',
        margin: 0,
        fontFamily: "'Inter', 'Roboto', 'Segoe UI', sans-serif",
        color: 'var(--text-1)',
        backgroundColor: 'var(--app-bg)',
      },
      '#root': {
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
      a: {
        color: 'inherit',
        textDecoration: 'none',
      },
      'img, video': {
        maxWidth: '100%',
        display: 'block',
      },
      'ul, ol': {
        padding: 0,
        margin: 0,
        listStyle: 'none',
      },
      '::selection': {
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(90, 75, 252, 0.35)' : 'rgba(90, 75, 252, 0.22)',
      },
      '@media (max-width: 768px)': {
        '.MuiGridLegacy-container, .MuiGrid-container': {
          width: '100% !important',
          marginLeft: '0 !important',
        },
        '.MuiGridLegacy-container > .MuiGridLegacy-item, .MuiGrid-container > .MuiGrid-item': {
          paddingLeft: '0 !important',
        },
      },
    })}
  />
);

export default GlobalStyles;
